var map = {
	"./bed-cushion.webp": 326,
	"./bench-window-back.webp": 327,
	"./bench-window-seat.webp": 328,
	"./bolster.webp": 329,
	"./chair-with-no-back.webp": 330,
	"./chair.webp": 331,
	"./chaise.webp": 332,
	"./custom-template.webp": 333,
	"./filling-only.webp": 334,
	"./loveseat.webp": 335,
	"./lumbar.webp": 336,
	"./ottoman.webp": 337,
	"./sofa.webp": 338,
	"./toss.webp": 339
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 325;